import buildSizeMap from 'lib/buildSizeMap';
/**
 * Builds the responsive mapping for the ad slot sizes according to the sites breakpoints
 * @private
 * @param {object} breakpoints - List of page breakpoint sizes
 * @param {object} sizeMapping - List of slot sizes, by breakpoint size
 * @return {object}
 */
export default function buildResponsiveSizeMap(breakpoints, sizeMapping) {
  const { sizeMapping: SizeMappingBuilder } = window.googletag;

  const mapping = SizeMappingBuilder();

  Object.keys(breakpoints).forEach((key) => {
    const breakpoint = Array.isArray(breakpoints[key]) ?
      breakpoints[key] : String(breakpoints[key]).split(',');

    mapping.addSize(breakpoint, buildSizeMap(sizeMapping[key]));
  });
  return mapping.build();
}
